<div class="flex min-h-screen flex-col bg-white">

  <!-- Header -->
<app-header [homeRoute]="'/candidate/profile'"></app-header>

  <!-- Candidate Page Content -->
  <main class="flex-1">
    <router-outlet></router-outlet>
  </main>

  <!-- Footer -->
  <app-footer></app-footer>

</div>
